import React from 'react';
import { ICloudEntity } from 'common/module_interface/assets/ICloudEntity';
import { ThirdPartyChipWidget } from '../../../ThirdParty/Components/ChipWidgets/ChipWidgets';

export const AssetDetailsThirdPartyChipWidget: React.FC<{ cloudEntity: ICloudEntity }> = ({ cloudEntity }) => {
    return <ThirdPartyChipWidget assetLabels={cloudEntity?.assetLabels} />;
};
